module.exports = __webpack_public_path__ + "img/V-R-5-unload-connect-shadow.617e7c4c.png";